import * as React from 'react';
import { Box } from '../../../Box/Box.web.js';
import { useTheme } from '../../theming/useTheme.js';

var Highlight = function Highlight(_ref) {
  var children = _ref.children,
      search = _ref.search;
  if (!search || search.length < 1) return (
    /*#__PURE__*/
    React.createElement(React.Fragment, null, children)
  );
  var childText = children && String(children);
  if (!childText || childText.length < 1) return (
    /*#__PURE__*/
    React.createElement(React.Fragment, null, children)
  );
  var searchRegex = new RegExp("(".concat(search.replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'), ")"), 'i');
  var parts = childText.split(searchRegex);
  var theme = useTheme();
  return (
    /*#__PURE__*/
    React.createElement(React.Fragment, null, parts.map(function (part, index) {
      return searchRegex.test(part) ?
      /*#__PURE__*/
      React.createElement(Box, {
        as: "mark",
        "data-test": "elemental-Highlight-".concat(part, "-").concat(index),
        key: "".concat(part, "-").concat(index),
        backgroundColor: "transparent",
        textColor: theme.listItems.web.textColor
      }, part) : part;
    }))
  );
};

export { Highlight };